import type { User } from './auth/types';
import { isSuperAdmin } from './team';

/**
 * Ruta de "inicio" para un usuario: el super admin siempre va a /admin; una
 * empresa va a su página preferida (home_page, migr. 040): /inicio, /proyectos
 * o /reportes. Default /inicio. Se usa en RootRoute (al entrar por "/") y en
 * PublicOnlyRoute (redirect post-login cuando no hay destino previo).
 */
export function homePathFor(user: User | null | undefined): string {
  if (isSuperAdmin(user?.role)) return '/admin';
  const page = user?.home_page ?? 'inicio';
  return `/${page}`;
}
